/* eslint-disable no-unused-vars */
import { Box, Button, Checkbox, Grid } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAlert, setRefreshBox } from "../../store/action/action";
import { notification_handler, send_to_bhu } from "../../Services/Services";

function DataTable({ rows, loading }) {
  const dispatch = useDispatch();
  const { auth, refresh } = useSelector((state) => state);

  const role = auth.role;
  const subType = "terminate";
  const [remark, setRemark] = useState("");
  const [agreement, setAgreement] = useState({});
  const notificationCall = async (id, code) => {
    await notification_handler("TR1", id, code, auth.id);
  };

  async function handleRenewal(id, code) {
    try {
      const response = await send_to_bhu(
        {
          renewal_status: "Sent To Sr Manager For Renewal",
          additionalRemark: null,
        },
        id,
        auth.role,
        "renewal"
      );
      if (response.data.success) {
        await notification_handler("RN3", id, code, auth.id);
        dispatch(
          setAlert({
            variant: "success",
            open: true,
            message: "Agreement Sent To Sr Manager For Renewal.",
          })
        );
        dispatch(setRefreshBox());
      } else {
        dispatch(
          setAlert({
            variant: "error",
            open: true,
            message: "Something went wrong! Please again later.",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAlert({
          open: true,
          variant: "error",
          message: "Something Went Wrong Please Try Again Later.",
        })
      );
    }
  }
  async function handleTerminate(id, code) {
    try {
      const response = await send_to_bhu(
        {
          terminate_status: "Sent To Sr Manager For Termination",
          additionalRemark: null,
        },
        id,
        role,
        "terminate"
      );
      if (response.data.success) {
        notificationCall(id, code);
        dispatch(
          setAlert({
            variant: "success",
            open: true,
            message: "Agreement Sent To Sr Manager For Terminate",
          })
        );
        dispatch(setRefreshBox());
      } else {
        dispatch(
          setAlert({
            variant: "error",
            open: true,
            message: "Something went wrong! Please again later.",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAlert({
          open: true,
          variant: "error",
          message: "Something Went Wrong Please Try Again Later.",
        })
      );
    }
  }

  const renderDetailsButton = (e) => {
    const id = e.id;
    return (
      <Box
        sx={{
          display: "flex",
          gap: "1rem",
          width: "100%",
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={{
            backgroundColor: "rgb(103 185 68 / 89%)",
            color: "white",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/renewal-view-agreement/${id}`);
          }}
        >
          View
        </Button>
      </Box>
    );
  };

  function actionButton(e) {
    const id = e.id;
    const code = e.row.code;
    return (
      <Grid container>
        <Box sx={{ display: "flex", gap: 2 }}>
          {(e.row.status === "Sent Back From BUH" ||
            e.row.renewal_status === "Request Approved for Renewal" ||
            e.row.status === "Sent Back From Sr Manager" ||
            e.row.status === "Sent Back From Finance Team" ||
            e.row.status === "Sent Back From Operations") && (
            <>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  size="small"
                  style={{
                    backgroundColor: "rgb(103 185 68 / 89%)",
                    color: "white",
                    fontSize: "12px",
                    textTransform: "capitalize",
                  }}
                  onClick={async (e) => {
                    e.stopPropagation();
                    navigate(`/renewal-edit-agreement/${id}`);
                  }}
                >
                  Edit
                </Button>
              </Grid>

              <Grid item xs={6}></Grid>
            </>
          )}
        </Box>

        {(e.row.status === "Sent Back From Finance Team Termination" ||
          e.row.status === "Sent Back From Operations Termination" ||
          e.row.terminate_status === "Request Approved for Termination" ||
          e.row.status === "Sent Back From Sr Manager Termination") &&
          e.row.status !== "Terminated By Manager" &&
          e.row.status !== "Terminated By Sr Manager" &&
          e.row.status !== "Terminated By Operations" && (
            <Grid item xs={6}>
              <Button
                variant="contained"
                size="small"
                style={{
                  backgroundColor: "#b53f3f",
                  color: "white",
                  fontSize: "12px",
                  textTransform: "capitalize",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/renewal-deposit-refund/${id}`);
                }}
              >
                Edit
              </Button>
            </Grid>
          )}
        {(e.row.renewal_status === "Pending For Renewal" ||
          e.row.terminate_status ===
            "Sent Back For Termination Rectification" ||
          e.row.renewal_status === "Sent Back For Renewal Rectification") &&
          e.row.renewal_status !== "Sent To Sr Manager For Renewal" &&
          e.row.terminate_status !== "Sent To Sr Manager For Termination" &&
          e.row.terminate_status !== "Request Approved for Termination" &&
          e.row.status !== "Sent Back From Operations Termination" &&
          e.row.status !== "Terminated By Sr Manager" &&
          e.row.status !== "Terminated By Operations" &&
          e.row.status !== "Terminated By Finance" &&
          e.row.status !== "Sent Back From Finance Team Termination" &&
          e.row.renewal_status !== "Request Approved for Renewal" &&
          e.row.status !== "Approved for Termination" && (
            <>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{
                    backgroundColor: "rgb(103 185 68 / 89%)",
                    color: "white",
                    fontSize: "12px",
                    textTransform: "capitalize",
                  }}
                  onClick={(e) => {
                    handleRenewal(id, code);
                  }}
                >
                  Renew
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  size="small"
                  style={{
                    backgroundColor: "#b53f3f",
                    color: "white",
                    fontSize: "12px",
                    textTransform: "capitalize",
                  }}
                  onClick={async (e) => {
                    e.stopPropagation();
                    handleTerminate(id);
                  }}
                >
                  Terminate
                </Button>
              </Grid>
            </>
          )}
      </Grid>
    );
  }

  const navigate = useNavigate();
  const [ids, setIds] = useState([]);

  const handleSwitch = (e) => {
    let idVar = Number(e.target.name);
    if (ids.includes(idVar)) {
      setIds(ids.filter((i) => i !== idVar));
    } else {
      setIds([...ids, idVar]);
    }
  };

  const columns = [
    {
      field: "checkbox",
      disableColumnMenu: true,
      sortable: false,
      minWidth: 30,
      type: "number",
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      renderCell: (params) => (
        <>
          {params.formattedValue === "Pending For Renewal" ? (
            <Checkbox
              onChange={handleSwitch}
              name={params.id}
              checked={ids.includes(params.id) ? true : false}
            />
          ) : (
            <Checkbox disabled={true} />
          )}
        </>
      ),
    },
    {
      field: "code",
      headerName: "Code",
      minWidth: 130,
      type: "number",
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "branch_code",
      headerName: "Branch Code",
      minWidth: 180,
      flex: 1,
      type: "number",
      headerClassName: "dataGridHeader",
      headerAlign: "center",
    },
    {
      field: "type",
      headerName: "Type",
      minWidth: 130,
      type: "number",
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "name",
      headerName: " Landlord Name",
      minWidth: 230,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },

    {
      field: "location",
      headerName: "Location",
      minWidth: 230,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "address",
      headerName: "Address",
      minWidth: 230,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "city",
      headerName: "City",
      minWidth: 230,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "state",
      headerName: "State",
      minWidth: 230,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "deposit",
      headerName: "Deposit Amount",
      minWidth: 230,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "rentalAmount",
      headerName: "Rent Amount",
      minWidth: 200,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "expiry_day",
      headerName: "No. of Days to Expire",
      minWidth: 230,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "agreement_end_date",
      headerName: "Agreement Expiry Date",
      minWidth: 230,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },

    {
      field: "status",
      headerName: "Status",
      minWidth: 200,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "renewal_status",
      headerName: "Renewal Status",
      minWidth: 200,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "terminate_status",
      headerName: "Terminate Status",
      minWidth: 200,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "view",
      headerName: "View",
      minWidth: 250,
      flex: 1,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      renderCell: renderDetailsButton,
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 300,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
      renderCell: actionButton,
    },
  ];

  return (
    <>
      <Box
        sx={{
          height: "430px",
          px: 2,
          "& .dataGridHeader": {
            color: "#CACACA",
            textAlign: "left",
          },
          "& .green": {
            backgroundColor: "#E7FFE9",
            color: "#41CF2A",
          },
          "& .yellow": {
            backgroundColor: "#FEFFC8",
            color: "#C5C05B",
          },
          "& .red": {
            backgroundColor: "#FFEBE7",
            color: "#CF482A",
          },
          "& .statusCell": {
            maxHeight: "30px !important",
            minHeight: "25px !important",
            textAlign: "center !important",
            borderRadius: "10px !important",
            m: "auto",
          },
          "& .allCell": {
            justifyContent: "center !important",
          },
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={6}
          rowsPerPageOptions={[6]}
          loading={loading}
          sx={{ color: "black !important", minWidth: "50px" }}
          getCellClassName={(parms) => {
            let cellClass = [];

            if (parms.field === "status" || parms.field === "renewal_status") {
              if (
                (parms.field === "status" ||
                  parms.field === "renewal_status") &&
                (parms.row.renewal_status === "Approved for Renewal" ||
                  parms.row.status === "Deposited" ||
                  parms.row.status === "Pending For Renewal" ||
                  parms.row.status === "Request Approved for Renewal" ||
                  parms.row.renewal_status === "Approved for Renewal" ||
                  parms.row.renewal_status === "Approved Termination" ||
                  parms.row.status === "Approved")
              ) {
                cellClass.push("green statusCell");
              } else if (
                parms.field === "renewal_status" &&
                (parms.row.status === "Pending For Renewal" ||
                  parms.row.status === "Terminated By Manager" ||
                  parms.row.status === "Terminated By Sr Manager" ||
                  parms.row.status === "Sent To Sr Manager For Termination" ||
                  parms.row.status ===
                    "Sent Back From Sr Manager Termination" ||
                  parms.row.status ===
                    "Sent Back From Operations Termination" ||
                  parms.row.status === "Terminated By Operations" ||
                  parms.row.status ===
                    "Sent Back From Finance Team Termination" ||
                  parms.row.status === "Approved for Termination" ||
                  parms.row.renewal_status ===
                    "Sent To Sr Manager For Renewal" ||
                  parms.row.renewal_status === "Sent To Operations For Renewal")
              ) {
                cellClass.push("green statusCell");
              } else if (
                (parms.field === "status" ||
                  parms.field === "renewal_status") &&
                (parms.row.status === "Sent To Sr Manager For Renewal" ||
                  parms.row.status === "Draft" ||
                  parms.row.status === "Sent To Sr Manager" ||
                  parms.row.status === "Sent To Operations" ||
                  parms.row.status === "Sent To BUH" ||
                  parms.row.status === "Sent To Finance Team")
              ) {
                cellClass.push("yellow statusCell");
              } else if (
                (parms.field === "terminate_status" ||
                  parms.field === "status" ||
                  parms.row.status != null) &&
                (parms.row.terminate_status ===
                  "Sent Back For Termination Rectification" ||
                  parms.row.terminate_status ===
                    "Sent To Sr Manager For Termination" ||
                  parms.row.terminate_status ===
                    "Request Approved for Termination" ||
                  parms.row.terminate_status === "Sent Back From Sr Manager" ||
                  parms.row.status === "Terminated By Manager" ||
                  parms.row.status === "Sent For Termination" ||
                  parms.row.status ===
                    "Sent Back From Operations Termination" ||
                  parms.row.status.includes("termi".toLowerCase()) ||
                  parms.row.status === "Request Approved For Terminate" ||
                  parms.row.status === "Terminated By Sr Manager" ||
                  parms.row.status === "Terminated By Operations" ||
                  parms.row.status === "Sent To Operations For Termination" ||
                  parms.row.status === "Approved for Termination" ||
                  parms.row.status ===
                    "Sent Back From Finance Team Termination" ||
                  parms.row.status === "Sent Back From Finance Team" ||
                  parms.row.status === "Sent Back From Operations" ||
                  parms.row.status === "Sent Back From Sr Manager" ||
                  parms.row.status === "Sent Back From BUH")
              ) {
                cellClass.push("red statusCell");
              }
            } else if (parms.field === "terminate_status") {
              if (
                parms.field === "terminate_status" &&
                (parms.row.terminate_status === "Approved For Termination" ||
                  parms.row.terminate_status ===
                    "Request Approved for Termination" ||
                  parms.row.terminate_status ===
                    "Sent Back For Termination Rectification" ||
                  parms.row.status === "Terminated By Operations" ||
                  parms.row.terminate_status === "Approved Termination" ||
                  (parms.row.terminate_status != null &&
                    parms.row.terminate_status.includes("Termi")))
              ) {
                cellClass.push("red statusCell");
              }
            }
            cellClass.push("allCell");

            return cellClass;
          }}
        ></DataGrid>
      </Box>
    </>
  );
}

export default DataTable;
